'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'baby';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f77c';
var svgPathData = 'M406.2 160.2c-17.5-25.25-52.13-32-77.88-14.5l-36.38 25c-32.88 22.66-87.05 33.63-135.8 0l-36.38-25c-25.75-17.5-60.38-10.75-77.88 14.5c-17.5 25.5-11 60.5 14.5 78l36.38 24.88c10.88 7.5 22.75 14.12 35.38 19.75v22.62l-54.25 56.25c-19.25 17.75-23.5 46.38-10 69.25l38.25 56.13C112.3 502.5 129.9 512 148.7 512c10 0 19.78-2.75 28.4-7.75c13-7.75 52.25-40.5 2-96.5l18.38-11.62c17.5 6.072 40.47 4.379 53.09 0l18.38 11.62c-50.25 56-11 88.75 2 96.5C279.5 509.3 289.3 512 299.3 512c18.75 0 36.33-9.5 46.58-24.88l38.25-56.13c13.5-22.88 9.25-51.5-10-69.25l-54.25-56.25V282.9c12.63-5.625 24.5-12.25 35.38-19.75l36.38-24.88C417.2 220.7 423.7 185.7 406.2 160.2zM169.3 443.7c6.625 11.5 2.875 26.13-8.5 33c-10.77 6.254-25.8 3.496-33-8.5l-36.5-53.5c-6-10.12-3.75-23.25 5.5-30.75l38.75-41.25c.75 .875 27.55 28.51 36.88 37.88l-29.38 27.62L169.3 443.7zM252 358.6c-13.07 13.07-43.34 12.75-56.09 0l-35.88-35.88V303.1h127.8v18.75L252 358.6zM351.2 383.1c9.25 7.5 11.5 20.62 5.5 30.75l-36.5 53.5c-7.262 12.1-22.32 14.7-33 8.5c-11.38-6.875-15.13-21.5-8.5-33l26.25-35.5l-29.38-27.62c9.328-9.361 36.13-37 36.88-37.88L351.2 383.1zM373.5 211.7l-36.38 25c-12.48 8.521-25.78 15.4-39.57 20.83c-5.889 2.318-9.678 8.094-9.678 14.42H160.1c0-6.33-3.789-12.11-9.68-14.42c-13.79-5.43-27.09-12.3-39.57-20.83l-36.38-25c-26.38-18.12 1.25-57.25 27.25-39.5l36.25 24.88c1.762 1.207 83.97 60.38 172.1 0l36.25-24.88C372.3 154.5 399.9 193.6 373.5 211.7zM224 159.1c44.21-.043 79.99-35.78 79.99-79.1c0-44.22-35.78-79.96-79.99-79.1C179.8 .043 144 35.77 144 79.1C144 124.2 179.8 159.1 224 159.1zM224 32c26.46 .043 47.92 21.52 47.92 47.99c0 26.47-21.46 47.95-47.92 47.99C197.5 127.9 176.1 106.5 176.1 79.99C176.1 53.52 197.5 32.04 224 32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBaby = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;